<template>
  <div class="wrapper" id="app">
    <!-- 向上 -->
    <div class="up setUp">
      <span id="zh" @click="getlang('zh')">{{$t('zh')}}</span>
      <span id="en" @click="getlang('en')">{{$t('en')}}</span>
    </div>
    <a @click.prevent="custormAnchor('sum_swiper')">
      <div class="up">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </div>
    </a>
    <!--头部、导航开始-->
    <header>
      <!--logo-->
      <div class="logo left">
        <router-link to="/">
          <img src="../assets/img/logo/logo.png"/>
        </router-link>
      </div>
      <!--菜单-->
      <div class="nav" @click="showNav"><i class="fa fa-bars fa-2x" aria-hidden="true"></i></div>
      <!--语言切换-->
      <!--<select class='language'  v-model="lang" @change="getlang">-->
      <!--<option value="zh">中</option>-->
      <!--<option value="en">英</option>-->
      <!--</select>-->
      <!--导航内容-->
      <ul>
        <li v-for="obj in  $t('nav')">
          <router-link :to="obj.href">{{obj.name}}</router-link>
        </li>
      </ul>
    </header>
    <!--头部、导航结束-->
    <!--主体开始-->
    <main id="home">
      <!--幻灯片开始-->
      <!--<div style="width: 100%;height: 6.5rem">-->
      <!--<video meted="meted" autoPlay="autoPlay" src='../assets/img/button/Slide_video.mp4' loop="loop" style="width: 100%;height: 100%;object-fit: fill">-->
      <!--<source src={video} type="video/mp4" />-->
      <!--</video>-->
      <!--<video src="../assets/img/button/Slide_video.mp4"  muted  autoplay="autoplay" loop="loop" style="width: 100%;height: 100%;object-fit: fill"></video>-->
      <!--</div>-->
      <div class="swiper-container" id="sum_swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="obj in swiper">
            <a :href="obj.href"><img :src="obj.src"/></a>
          </div>
        </div>
        <div class="wiper-container swiper_able"></div>
      </div>
      <!-- 幻灯片结束 -->
      <transition mode='out-in'>
        <router-view/>
      </transition>
    </main>
    <!--尾部-->
    <footer>
      <!--关于我们-->
      <!--<div class="AboutUs">-->
      <!--<span><strong>关于我们</strong></span>-->
      <!--<div class="introduce">&nbsp; &nbsp; &nbsp; &nbsp;{{AboutUs}}</div>-->
      <!--</div>-->
      <!--页面导航-->
      <div class="PageNabigation">
        <span><strong>{{$t('Pages')}}</strong></span>
        <ul>
          <li v-for="obj in $t('nav')">
            <router-link :to="obj.href">{{obj.name}}</router-link>
          </li>
        </ul>
      </div>
      <!--联系我们-->
      <div class="ContactUS">
        <span><strong>{{$t('ContactTitle')}}</strong><p style="font-size: 16px">{{$t('companyName')}}</p></span>
        <p v-for="obj in $t('ContactUs')">{{obj.name}}：{{obj.val}}</p>
      </div>

      <div class="ContactUS">
        <span><strong style="color: #031627">`</strong><p style="font-size: 16px">{{$t('companyNameMacao')}}</p></span>
        <p v-for="obj in $t('ContactUs2')">{{obj.name}}：{{obj.val}}</p>
      </div>

      <div class="ContactUS">
        <span><strong style="color: #031627">`</strong><p style="font-size: 16px">{{$t('companyNameHongKong')}}</p></span>
        <p v-for="obj in $t('ContactUs3')">{{obj.name}}：{{obj.val}}</p>
      </div>
      <div class="putOnRecords ">
        <!--珠海颢腾智胜科技有限公司 版权所有-->
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496541"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin: -5px 5px">
          <img src="../assets/img/logo/备案图标.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color: #fff">粤公网安备 44049102496541号</p>
        </a>
        <a href="https://beian.miit.gov.cn" target="_blank"  style="color: #fff;">粤ICP证19086620号</a>
      </div>

      <!--<div style="width:300px;margin:0 auto; padding:20px 0;">-->
      <!--</div>-->
    </footer>
  </div>
</template>

<script>
  import Swiper from 'swiper/dist/js/swiper'
  import $ from 'jquery'

  export default {
    name: 'navigation',
    data () {
      return {
        lang: 'zh',
        //显示/隐藏菜单
        showNavs: true,
        //幻灯片
        swiper: [
          {
            src: require('@/assets/img/banner/banner_lantern_slide_1.jpg'),
            href: '#'
          },
          {
            src: require('@/assets/img/banner/banner_lantern_slide_2.jpg'),
            href: '#'
          },
          {
            src: require('@/assets/img/banner/banner_lantern_slide_3.jpg'),
            href: '#'
          },
        ],
      }
    },
    mounted () {
      this.mySwiper()
      this.getlang(this.lang)
    },
    methods: {
      //幻灯片
      mySwiper: function () {
        var mySwiper = new Swiper('.swiper-container', {
          autoplay: true, //可选选项，自动滑动
          pagination: {
            el: '.wiper-container',
            clickable: true,
          },
          loop: true,
        })
      },
      //  语言切换
      getlang: function (lang) {
        if (document.getElementById('title')) {
          if (lang === 'zh') {
            document.getElementById('title').innerText = '颢腾集团'
          } else if (lang === 'en') {
            document.getElementById('title').innerText = 'Hao Teng group'
          }
        }
        document.getElementById('en').style.color = '#fff'
        document.getElementById('zh').style.color = '#fff'
        document.getElementById(lang).style.color = 'red'
        this.$i18n.locale = lang
      },
      //显示菜单
      showNav: function () {
        if (this.showNavs) {
          this.showNavs = false
          $('header>ul').css('display', 'block')
          $('header>ul').css('height', '100%')
        } else {
          this.showNavs = true
          $('header>ul').css('display', 'none')
          $('header>ul').css('height', '0')
        }
        //
        window.onresize = function () {
          if (document.body.clientWidth + 17 >= 935) {
            $('header>ul').css('display', 'flex')
          } else if (document.body.clientWidth + 17 < 935) {
            $('header>ul').css('display', 'none')
          }
        }
      },
      //锚点
      custormAnchor: function (id) {
        console.log(id)
        // 找到锚点
        let anchorElement = document.getElementById(id)
        // 如果对应id的锚点存在，就跳转到锚点
        if (anchorElement) {
          anchorElement.scrollIntoView({
            behavior: 'smooth', //滑动
            block: 'start',     //顶部
          })
        }
      }
    }
  }
</script>

<style scoped>
  @import "../../node_modules/swiper/dist/css/swiper.css";

  .language {
    float: right;
    margin: 40px 10px;
    width: 50px;

  }

  .putOnRecords {
    width: 100%;
    text-align: center;
    font-size: 14px;
  }

  .van-tabbar-item--active {
    color: #000;
  }

  .router-link-exact-active {
    color: #064C8D;
    font-weight: 600;
  }

  .logo img {
    width: 200px;
    margin: 0 100px;
    /*padding: 20px 0;*/
  }

  #app {
    position: relative;
    font-size: 16px;
  }

  /* 向上 */
  .up {
    cursor: pointer;
    width: 40px;
    height: 40px;
    background-color: #000000;
    position: fixed;
    right: 1%;
    bottom: 10%;
    border-radius: 50px;
    font-size: 25px;
    text-align: center;
    line-height: 40px;
    color: #FFFFFF;
    z-index: 100;
  }

  .setUp {
    bottom: 15%;
    overflow: hidden;
    height: 85px;
    font-size: 20px;
  }

  .setUp *:hover {
    color: red;
  }

  /* 做浮动 */
  .left {
    float: left;
  }

  /* ul标签 */
  ul {
    list-style-type: none;
  }

  /*导航开始*/
  header {
    width: 100%;
    height: 100px;
    position: fixed;
    padding: 0 30px 0 0;
    /*overflow: hidden;*/
    transition: all 0.5s ease-out;
    background: linear-gradient(to bottom, #fff 0%, rgba(255, 255, 255, 0.5) 100%);
    z-index: 100;
    font-size: 0.2rem;
  }

  header:hover {
    background-color: #fff;
    box-shadow: 0 0 5px 0 #000;
  }

  header > ul {
    transition: height 0.5s;
    float: right;
    display: flex;
    align-self: center;
    padding: 35px 0;
  }

  header > ul li {
    line-height: 30px;
    padding: 0 30px;
  }

  header > ul li:hover {
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }

  header > ul li a {
    color: #000;
    text-decoration: none;
  }

  .nav {
    width: 50px;
    border-radius: 10px;
    text-align: center;
    line-height: 50px;

    position: absolute;
    top: 50%;
    right: 60px;
    transform: translate(0, -50%);

    font-size: .6rem;
    font-weight: 900;

    display: none;
    z-index: 1000;
  }

  /*导航结束*/

  /*幻灯片开始*/
  #sum_swiper {
    position: relative;
    z-index: 1;
    height: 4.5rem;
  }

  .swiper-slide img {
    width: 100%;
    /*height: 100%;*/
    /*height: 7rem;*/
    /*min-height: 7rem;*/
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    position: absolute;
    z-index: 100000;
    text-align: center;
  }

  /*幻灯片结束*/
  /*尾部开始*/
  footer {
    background-color: rgba(3, 22, 39, .8);
    display: flex;
    flex-wrap: wrap;
    padding: 30px 65px 0 65px;
    font-size: 20px;
    color: #fff;
  }

  footer > div {
    width: 200px;
    margin: 0 10px 30px 10px;
    flex-grow: 1;
  }

  footer span {
    display: block;
    margin: 0 0 10px 0;
  }

  .AboutUs .introduce {
    line-height: 30px;
    font-size: 12px;
  }

  .PageNabigation {
    text-align: center;
  }

  .PageNabigation > ul {
    width: 200px;
    list-style-type: none;
    margin: auto;
  }

  .AboutUs .introduce,
  .PageNabigation > ul li,
  .ContactUS p {
    line-height: 30px;
  }

  .PageNabigation > ul li {
    border-top: 1px solid #fff;
  }

  .PageNabigation > ul li:last-of-type {
    border-bottom: 1px solid #fff;
  }

  .ContactUS p,
  .PageNabigation > ul a {
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }

  /*尾部结束*/
  @media screen and (max-width: 1024px) {
    #sum_swiper {
      height: 10rem;
    }

    .swiper-slide img {
      height: 10rem;
      text-align: center;
    }

    .swiper-slide img {
      height: 10rem;
      text-align: center;
    }

    header > ul {
      display: none;
      position: fixed;
      padding-top: 94px;
      left: 0;
      width: 100%;
      z-index: 100;
      /*height: 100;*/
      overflow: hidden;
    }

    header > ul li {
      line-height: 30px;
      padding: 0 30px;
      color: #E5DFD9;
      line-height: 40px;
      background-color: #fff;
    }

    header > ul:only-of-type li {
      border-top: 1px solid #000;
    }

    .nav {
      display: block;
    }
  }

  @media screen and (max-width: 768px) {
    footer {
      padding: 30px 10px 0 10px;
    }

    .PageNabigation > ul {
      width: 250px;
      list-style-type: none;
      margin: auto;
    }

    .logo img {
      width: 150px;
      margin: 0 30px;
      padding: 20px 0;
    }

    header > ul {
      padding-top: 91px;
    }

    header > ul li {
      font-size: 0.5rem;
    }


    .nav i {
      margin-top: 20px;
      font-size: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue